<template>
  <v-row v-if="ready" class="pt-5">
    <v-col cols="10" offset="1">
      <v-row>
        <v-col
          cols="12"
          v-for="(row, index, count) in data"
          :key="`row${index}`"
        >
          <ResultsScale :row="row" :title="benchmarks[count]" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
import { mapState } from "vuex";
import ResultsScale from "@/components/results/tov/ResultsScale";
// import { store } from "@/store.js";
export default {
  name: "ResultsTovSummary",
  data() {
    return {
      doc: null,
      intervalId: null,
      ready: false,
      max: 2,
      data: null,
      benchmarks: [],
    };
  },
  components: {
    ResultsScale,
  },
  props: {
    id: String,
    summaryMode: {
      type: String,
      default: "combined",
    },
  },
  mounted() {
    // this.getList();
    this.init();
  },
  computed: {
    ...mapState(["exTov", "tov"]),
    filteredList() {
      let list = [];
      this.exTov.forEach((item) => {
        list.push(item.tov);
      });
      return list;
    },
    unit() {
      return this.max / 100;
    },
    grouped() {
      return lodash.groupBy(this.exTov, "index");
    },
  },
  methods: {
    init() {
      this.getRefs();
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.exTov && this.tov && this.filteredList && this.benchmarks) {
        this.ready = true;
        this.createData();
        clearInterval(this.intervalId);
      }
    },
    getRefs() {
      let ref = fb.projectsCollection.where("id", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          // console.log("getting refs", result);
          result.forEach((doc) => {
            let post = doc.data();
            post.benchmarksOrder.forEach((b) => {
              items.push(b);
            });
          });
          if (items) {
            this.benchmarks = items.map((item) => item.title);
          }
        })
        .catch(function() {});
    },
    createData() {
      console.log("create data");
      let arr = {};
      this.filteredList.forEach((x) => {
        // split the data up into the exercises
        Object.keys(x).forEach((key) => {
          let filtered = this.filteredList.map((item) => item[key]);
          arr[key] = filtered;
        });
      });
      //
      const ordered = Object.keys(arr)
        .sort()
        .reduce((obj, key) => {
          obj[key] = arr[key];
          return obj;
        }, {});
      //
      // Object.entries(ordered).forEach((a) => {
      //   // console.log("a", a);
      //   Object.entries(a).forEach((b) => {
      //     // console.log("key", b);
      //     Object.entries(b).forEach(([c, d]) => {
      //       console.log("c", c);
      //       console.log("d", d);
      //     });
      //   });
      // });

      //
      this.data = ordered;
    },
    reduceItems(arr) {
      let items = [];
      let distribution = Object.entries(arr).reduce(
        (acum, cur) => Object.assign(acum, { [cur]: (acum[cur] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      return items;
    },
  },
};
</script>
